// export const WidgetRename = ({
//     setRenameDeviceModal,
//     currentDevice,
//     tempTabIndexDevices,
//     activeTabIndex,
//     selectedDevice,
//     clickedDeviceIndex,
//     tabNameInput,
//     tempImages,
//     setTempImages,
//     setUpdatedImages,
//     multipleDevices,
//     setMultipleDevices,
//     setDevicesName,
//     devicesName,
//     setIndexesDeviceName,
//     indexesDeviceName,
//     tempTabIndexController,
//     multipleController,
//     setMultipleController,
//     tempTabIndexIO,
//     multipleIO,
//     setMultipleIO,
//     tempTabIndexFlowM,
//     multipleFlowM,
//     setMultipleFlowM,
//     tempTabIndexEnergyM,
//     multipleEnergyM,
//     setMultipleEnergyM
// }) => {
//     setRenameDeviceModal(false);
//     // For Indicator
//     if (currentDevice === "Indicator") {
//         if (Object.keys(tempTabIndexDevices).length > 0) {
//             const particularDevice = tempTabIndexDevices[activeTabIndex];
//             // condition to check if device already exist or not
//             if (particularDevice !== undefined) {
//                 if (selectedDevice?.id) {

//                     if (
//                         tempTabIndexDevices[activeTabIndex].some(
//                             (device) => device.id === selectedDevice.id
//                         )
//                     ) {
//                         if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
//                             const updatedDeviceName = tempTabIndexDevices[activeTabIndex];
//                             updatedDeviceName[clickedDeviceIndex].name = tabNameInput;
//                             tempTabIndexDevices[activeTabIndex] = updatedDeviceName;

//                             const originalDeviceIndex = tempImages.findIndex(
//                                 (data) => data.id === selectedDevice.id
//                             );
//                             const updatedTempImages = [...tempImages];

//                             const updatedData = {
//                                 ...updatedTempImages[originalDeviceIndex],
//                                 name: tabNameInput,
//                             };
//                             updatedTempImages[originalDeviceIndex] = updatedData;
//                             setTempImages(updatedTempImages);
//                             setUpdatedImages(updatedTempImages);
//                         }
//                     }
//                 }
//             }
//         }

//         if (multipleDevices.length > 1) {
//             if (!selectedDevice?.id) {
//                 const updatedDeviceName = multipleDevices;
//                 updatedDeviceName[clickedDeviceIndex].deviceName = tabNameInput;
//                 setMultipleDevices(updatedDeviceName);
//                 setDevicesName(devicesName.concat(tabNameInput));
//                 setIndexesDeviceName(indexesDeviceName.concat(clickedDeviceIndex));
//             }
//         }
//     }

//     // For Controller
//     if (currentDevice === "Controller") {
//         if (Object.keys(tempTabIndexController).length > 0) {
//             const particularDevice = tempTabIndexController[activeTabIndex];
//             // condition to check if device already exist or not
//             if (particularDevice !== undefined) {
//                 if (selectedDevice?.id) {

//                     if (
//                         tempTabIndexController[activeTabIndex].some(
//                             (device) => device.id === selectedDevice.id
//                         )
//                     ) {
//                         if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
//                             const updatedDeviceName = tempTabIndexController[activeTabIndex];
//                             updatedDeviceName[clickedDeviceIndex].name = tabNameInput;
//                             tempTabIndexController[activeTabIndex] = updatedDeviceName;

//                             const originalDeviceIndex = tempImages.findIndex(
//                                 (data) => data.id === selectedDevice.id
//                             );
//                             const updatedTempImages = [...tempImages];

//                             const updatedData = {
//                                 ...updatedTempImages[originalDeviceIndex],
//                                 name: tabNameInput,
//                             };
//                             updatedTempImages[originalDeviceIndex] = updatedData;
//                             setTempImages(updatedTempImages);
//                             setUpdatedImages(updatedTempImages);
//                         }
//                     }
//                 }
//             }
//         }

//         if (multipleController.length > 1) {
//             if (!selectedDevice?.id) {
//                 const updatedDeviceName = [...multipleController];
//                 updatedDeviceName[clickedDeviceIndex].deviceName = tabNameInput;
//                 setMultipleController(updatedDeviceName);
//             }
//         }
//     }

//     if (currentDevice === "DigitalIO") {
//         const particularDevice = tempTabIndexIO[activeTabIndex];
//         if (Object.keys(tempTabIndexIO).length > 0) {
//             if (particularDevice !== undefined) {
//                 if (selectedDevice?.id) {

//                     if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
//                         const updatedDeviceName = tempTabIndexIO[activeTabIndex];
//                         updatedDeviceName[clickedDeviceIndex].name = tabNameInput;
//                         tempTabIndexIO[activeTabIndex] = updatedDeviceName;

//                         const originalDeviceIndex = tempImages.findIndex(
//                             (data) => data.id === selectedDevice.id
//                         );
//                         const updatedTempImages = [...tempImages];

//                         const updatedData = {
//                             ...updatedTempImages[originalDeviceIndex],
//                             name: tabNameInput,
//                         };
//                         updatedTempImages[originalDeviceIndex] = updatedData;
//                         setTempImages(updatedTempImages);
//                         setUpdatedImages(updatedTempImages);
//                     }
//                 }
//             }
//         }
//         if (multipleIO.length > 1) {
//             if (!selectedDevice?.id) {
//                 const updatedDeviceName = multipleIO;
//                 updatedDeviceName[clickedDeviceIndex].deviceName = tabNameInput;
//                 setMultipleIO(updatedDeviceName);
//             }
//         }
//     }

//     if (currentDevice === "FlowMeter") {
//         const particularDevice = tempTabIndexFlowM[activeTabIndex];
//         if (Object.keys(tempTabIndexFlowM).length > 0) {
//             if (particularDevice !== undefined) {
//                 if (selectedDevice?.id) {

//                     if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
//                         const updatedDeviceName = tempTabIndexFlowM[activeTabIndex];
//                         updatedDeviceName[clickedDeviceIndex].name = tabNameInput;
//                         tempTabIndexFlowM[activeTabIndex] = updatedDeviceName;

//                         const originalDeviceIndex = tempImages.findIndex(
//                             (data) => data.id === selectedDevice.id
//                         );
//                         const updatedTempImages = [...tempImages];

//                         const updatedData = {
//                             ...updatedTempImages[originalDeviceIndex],
//                             name: tabNameInput,
//                         };
//                         updatedTempImages[originalDeviceIndex] = updatedData;
//                         setTempImages(updatedTempImages);
//                         setUpdatedImages(updatedTempImages);
//                     }
//                 }
//             }
//         }

//         if (multipleFlowM.length > 1) {
//             if (!selectedDevice?.id) {
//                 const updatedDeviceName = multipleFlowM;
//                 updatedDeviceName[clickedDeviceIndex].deviceName = tabNameInput;
//                 setMultipleFlowM(updatedDeviceName);
//             }
//         }
//     }

//     if (currentDevice === "EnergyMeter") {
//         if (Object.keys(tempTabIndexEnergyM).length > 0) {
//             const particularDevice = tempTabIndexEnergyM[activeTabIndex];
//             if (particularDevice !== undefined) {

//                 if (selectedDevice?.id) {

//                     if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
//                         const updatedDeviceName = tempTabIndexEnergyM[activeTabIndex];
//                         updatedDeviceName[clickedDeviceIndex].name = tabNameInput;
//                         tempTabIndexEnergyM[activeTabIndex] = updatedDeviceName;

//                         const originalDeviceIndex = tempImages.findIndex(
//                             (data) => data.id === selectedDevice.id
//                         );
//                         const updatedTempImages = [...tempImages];

//                         const updatedData = {
//                             ...updatedTempImages[originalDeviceIndex],
//                             name: tabNameInput,
//                         };
//                         updatedTempImages[originalDeviceIndex] = updatedData;
//                         setTempImages(updatedTempImages);
//                         setUpdatedImages(updatedTempImages);
//                     }
//                 }
//             }
//         }

//         if (multipleEnergyM.length > 1) {
//             if (!selectedDevice?.id) {
//                 const updatedDeviceName = multipleEnergyM;
//                 updatedDeviceName[clickedDeviceIndex].deviceName = tabNameInput;
//                 setMultipleEnergyM(updatedDeviceName);
//             }
//         }
//     }
// };


export const WidgetRename = ({
    setRenameDeviceModal,
    currentDevice,
    tempTabIndexDevices,
    activeTabIndex,
    selectedDevice,
    clickedDeviceIndex,
    tabNameInput,
    tempImages,
    setTempImages,
    setUpdatedImages,
    multipleDevices,
    setMultipleDevices,
    setDevicesName,
    devicesName,
    setIndexesDeviceName,
    indexesDeviceName,
    tempTabIndexController,
    multipleController,
    setMultipleController,
    tempTabIndexIO,
    multipleIO,
    setMultipleIO,
    tempTabIndexFlowM,
    multipleFlowM,
    setMultipleFlowM,
    tempTabIndexEnergyM,
    multipleEnergyM,
    setMultipleEnergyM
}) => {
    setRenameDeviceModal(false);

    const updateDeviceName = (tempTabIndex, multipleDevices, setMultipleDevices) => {
        const particularDevice = tempTabIndex[activeTabIndex];

        if (Object.keys(tempTabIndex).length > 0 && particularDevice !== undefined) {
            if (selectedDevice?.id) {
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    particularDevice[clickedDeviceIndex].name = tabNameInput;
                    tempTabIndex[activeTabIndex] = particularDevice;

                    const originalDeviceIndex = tempImages.findIndex(data => data.id === selectedDevice.id);
                    if (originalDeviceIndex !== -1) {
                        const updatedTempImages = [...tempImages];
                        updatedTempImages[originalDeviceIndex] = { ...updatedTempImages[originalDeviceIndex], name: tabNameInput };
                        setTempImages(updatedTempImages);
                        setUpdatedImages(updatedTempImages);
                    }
                }
            }
        }

        if (multipleDevices.length > 1 && !selectedDevice?.id) {
            const updatedDeviceName = [...multipleDevices];
            updatedDeviceName[clickedDeviceIndex].deviceName = tabNameInput;
            setMultipleDevices(updatedDeviceName);
        }
    };

    const deviceMappings = {
        "Indicator": { tempTabIndex: tempTabIndexDevices, multipleDevices, setMultipleDevices },
        "Controller": { tempTabIndex: tempTabIndexController, multipleDevices: multipleController, setMultipleDevices: setMultipleController },
        "DigitalIO": { tempTabIndex: tempTabIndexIO, multipleDevices: multipleIO, setMultipleDevices: setMultipleIO },
        "FlowMeter": { tempTabIndex: tempTabIndexFlowM, multipleDevices: multipleFlowM, setMultipleDevices: setMultipleFlowM },
        "EnergyMeter": { tempTabIndex: tempTabIndexEnergyM, multipleDevices: multipleEnergyM, setMultipleDevices: setMultipleEnergyM }
    };

    if (deviceMappings[currentDevice]) {
        updateDeviceName(deviceMappings[currentDevice].tempTabIndex, deviceMappings[currentDevice].multipleDevices, deviceMappings[currentDevice].setMultipleDevices);
    }
};


